import TotalEmployeesTable from "../BrsrTables/TotalEmployeesTable";
import TotalEmployeesTable2 from "../BrsrTables/TotalEmployeesTable2";
import GrievanceMechanismTable from "../BrsrTables/GrievanceMechanismTable";
import ShareholdingTable from "../BrsrTables/ShareholdingTable";
import MaterialIssuesTable from "../BrsrTables/MaterialIssuesTable";
import DisclosureTable from "../BrsrTables/DisclosureTable";
import BoardReviewTable from "../BrsrTables/BoardReviewTable";
import ReviewFrequencyTable from "../BrsrTables/ReviewFrequencyTable";
import PolicyGapReasonTable from "../BrsrTables/PolicyGapReasonTable";
import TrainingAwarenessTable from "../BrsrTables/TrainingAwarenessTable";
import LegalActionsTable from "../BrsrTables/LegalActionsTable";
import CaseStudiesTable from "../BrsrTables/CaseStudiesTable";
import ConflictOfInterestTable from "../BrsrTables/ConflictOfInterestTable";
import AccountsPayableTable from "../BrsrTables/AccountsPayableTable";
import ConcentrationMetricsTable from "../BrsrTables/ConcentrationMetricsTable";
import AwarenessProgramTable from "../BrsrTables/AwarenessProgramTable";
import ImprovementImpactTable from "../BrsrTables/ImprovementImpactTable";
import ProductRiskTable from "../BrsrTables/ProductRiskTable";
import RecycledMaterialTable from "../BrsrTables/RecycledMaterialTable";
import WasteManagementTable from "../BrsrTables/WasteManagementTable";
import ReclaimedPackagingTable from "../BrsrTables/ReclaimedPackagingTable";
import EmployeeBenefitCoverageTable from "../BrsrTables/EmployeeBenefitCoverageTable";
import EmployeeCountComparisonTable from "../BrsrTables/EmployeeCountComparisonTable";
import WorkersBenefitCoverageTable from "../BrsrTables/WorkerBenefitCoverageTable";
import WellBeingCostTable from "../BrsrTables/WellBeingCostTable";
import StatutoryBenefitsTable from "../BrsrTables/StatutoryBenefitsTable";
import ReturnToWorkRateTable from "../BrsrTables/ReturnToWorkRateTable";
import ReclaimedProductTable from "../BrsrTables/ReclaimedProductTable";
import UnionAssociationTable from "../BrsrTables/UnionAssociationTable";
import TrainingMeasuresTable from "../BrsrTables/TrainingMeasuresTable";
import WorkforceFYTable from "../BrsrTables/WorkforceFYTable";
import SafetyIncidentTable from "../BrsrTables/SafetyIncidentTable";
import PfGratuityDisputeTable from "../BrsrTables/PfGratuityDisputeTable";
import AssessmentTable from "../BrsrTables/AssessmentTable";
import RehabilitationEmploymentTable from "../BrsrTables/RehabilitationEmploymentTable";
import ValueChainAssessmentTable from "../BrsrTables/ValueChainAssessmentTable";
import StakeholderEngagementTable from "../BrsrTables/StakeholderEngagementTable";
import CoverageComparisonTable from "../BrsrTables/CoverageComparisonTable";
import WageDistributionTable from "../BrsrTables/WageDistributionTable";
import RemunerationTable from "../BrsrTables/RemunerationTable";
import FemaleWagePercentageTable from "../BrsrTables/FemaleWagePercentageTable";
import HumanRightsComplaintsTable from "../BrsrTables/HumanRightsComplaintTable";
import PoshComplaintsTable from "../BrsrTables/PoshComplaintsTable";
import PlantAssessmentTable from "../BrsrTables/PlantAssessmentTable";
import PartnerEthicsAssessmentTable from "../BrsrTables/PartnerEthicsAssessmentTable";
import EnergyConsumptionTable from "../BrsrTables/EnergyConsumptionTable";
import WaterWithdrawalAndConsumptionTable from "../BrsrTables/WaterWithdrawalAndConsumptionTable";
import WaterDischargeTreatmentTable from "../BrsrTables/WaterDischargeTreatmentTable";
import AirPollutantEmissionTable from "../BrsrTables/AirPollutantEmissionTable";
import Scope1And2GHGEmissionTable from "../BrsrTables/Scope1And2GHGEmissionTable.jsx";
import WasteManagementEntityTable from "../BrsrTables/WasteManagementEntityTable.jsx";
import EnvironmentalClearanceTable from "../BrsrTables/EnvironmentalClearanceTable";
import EIAComplianceTable from "../BrsrTables/EIAComplianceTable";
import RegulatoryNonComplianceTable from "../BrsrTables/RegulatoryNonComplianceTable";
import WaterUsageAndDischargeTable from "../BrsrTables/WaterUsageAndDischargeTable";
import Scope3EmissionsTable from "../BrsrTables/Scope3EmissionsTable";
import InitiativeOutcomeTable from "../BrsrTables/InitiativeOutcomeTable";
import TradeAssociationsTable from "../BrsrTables/TradeAssociationsTable";
import LegalAuthoritiesTable from "../BrsrTables/LegalAuthoritiesTable";
import PublicPolicyAdvocacyTable from "../BrsrTables/PublicPolicyAdvocacyTable";
import SIATable from "../BrsrTables/SIATable";
import RehabilitationResettlementTable from "../BrsrTables/RehabilitationResettlementTable";
import SourcingBreakdownTable from "../BrsrTables/SourcingBreakdownTable";
import LocationDistributionTable from "../BrsrTables/LocationDistributionTable";
import SocialImpactActionTable from "../BrsrTables/SocialImpactActionTable";
import AspirationalDistrictTable from "../BrsrTables/AspirationalDistrictTable";
import TraditionalKnowledgeTable from "../BrsrTables/TraditionalKnowledgeTable";
import RegulatoryCaseTable from "../BrsrTables/RegulatoryCaseTable";
import CSRBeneficiariesTable from "../BrsrTables/CSRBeneficiariesTable";
import TurnoverParameterTable from "../BrsrTables/TurnoverParameterTable";
import CustomerComplaintsTable from "../BrsrTables/CustomerComplaintsTable";
import ProductRecallTable from "../BrsrTables/ProductRecallTable";
import ImprovementImpactTable1 from "../BrsrTables/ImprovementImpactTable1";

export const brsrTableRegistry = {
  brsr_table_1: {
    table: TotalEmployeesTable,
    tableData: "employeeTable",
    setTableData: "setEmployeeTable",
  },
  brsr_table_2: {
    table: TotalEmployeesTable2,
    tableData: "employeeTable2",
    setTableData: "setEmployeeTable2",
  },
  brsr_table_3: {
    table: ShareholdingTable,
    tableData: "shareholdingTable",
    setTableData: "setShareholdingTable",
  },
  brsr_table_4: {
    table: GrievanceMechanismTable,
    tableData: "grievanceTable",
    setTableData: "setGrievanceTable",
  },
  brsr_table_5: {
    table: MaterialIssuesTable,
    tableData: "materialTable",
    setTableData: "setMaterialTable",
  },
  brsr_table_6: {
    table: DisclosureTable,
    tableData: "disclosureData",
    setTableData: "setDisclosureData",
  },
  brsr_table_7: {
    table: BoardReviewTable,
    tableData: "reviewData",
    setTableData: "setReviewData",
  },
  brsr_table_8: {
    table: ReviewFrequencyTable,
    tableData: "frequencyData",
    setTableData: "setFrequencyData",
  },
  brsr_table_9: {
    table: PolicyGapReasonTable,
    tableData: "reasonData",
    setTableData: "setReasonData",
  },
  brsr_table_10: {
    table: TrainingAwarenessTable,
    tableData: "trainingData",
    setTableData: "setTrainingData",
  },
  brsr_table_11: {
    table: LegalActionsTable,
    tableData: "legalData",
    setTableData: "setLegalData",
  },
  brsr_table_12: {
    table: CaseStudiesTable,
    tableData: "caseStudies",
    setTableData: "setCaseStudies",
  },
  brsr_table_13: {
    table: EmployeeCountComparisonTable,
    tableData: "data",
    setTableData: "setData",
  },
  brsr_table_14: {
    table: ConflictOfInterestTable,
    tableData: "conflictData",
    setTableData: "setConflictData",
  },
  brsr_table_15: {
    table: AccountsPayableTable,
    tableData: "payableData",
    setTableData: "setPayableData",
  },
  brsr_table_16: {
    table: ConcentrationMetricsTable,
    tableData: "concentrationtableData",
    setTableData: "setConcentrationTableData",
  },
  brsr_table_17: {
    table: AwarenessProgramTable,
    tableData: "awarenessData",
    setTableData: "setAwarenessData",
  },
  brsr_table_18: {
    table: ImprovementImpactTable,
    tableData: "improvementData",
    setTableData: "setImprovementData",
  },
  brsr_table_19: {
    table: ImprovementImpactTable1,
    tableData: "improvementData1",
    setTableData: "setImprovementData1",
  },
  brsr_table_20: {
    table: ProductRiskTable,
    tableData: "productrows",
    setTableData: "setProductRows",
  },
  brsr_table_21: {
    table: RecycledMaterialTable,
    tableData: "recycledData",
    setTableData: "setRecycledData",
  },
  brsr_table_22: {
    table: WasteManagementTable,
    tableData: "wastedata",
    setTableData: "setWasteData",
  },
  brsr_table_23: {
    table: ReclaimedPackagingTable,
    tableData: "packagedata",
    setTableData: "setPackageData",
  },
  brsr_table_24: {
    table: EmployeeBenefitCoverageTable,
    tableData: "benefitTable",
    setTableData: "setBenefitTable",
  },
  brsr_table_25: {
    table: WorkersBenefitCoverageTable,
    tableData: "workersbenefitTable",
    setTableData: "setWorkersBenefitTable",
  },
  brsr_table_26: {
    table: WellBeingCostTable,
    tableData: "wellbeingdata",
    setTableData: "setWellbeingData",
  },
  brsr_table_27: {
    table: StatutoryBenefitsTable,
    tableData: "statutorydata",
    setTableData: "setStatutoryData",
  },
  brsr_table_28: {
    table: ReturnToWorkRateTable,
    tableData: "returndata",
    setTableData: "setReturnData",
  },
  brsr_table_29: {
    table: ReclaimedProductTable,
    tableData: "reclaimedproductdata",
    setTableData: "setReclaimedProductData",
  },
  brsr_table_30: {
    table: UnionAssociationTable,
    tableData: "uniondata",
    setTableData: "setUnionData",
  },
  brsr_table_31: {
    table: TrainingMeasuresTable,
    tableData: "trainingmeasuresdata",
    setTableData: "setTrainingMeasuresData",
  },
  brsr_table_32: {
    table: WorkforceFYTable,
    tableData: "fydata",
    setTableData: "setFyData",
  },
  brsr_table_33: {
    table: SafetyIncidentTable,
    tableData: "safetyData",
    setTableData: "setSafetyData",
  },
  brsr_table_34: {
    table: PfGratuityDisputeTable,
    tableData: "pfdata",
    setTableData: "setPfData",
  },
  brsr_table_35: {
    table: AssessmentTable,
    tableData: "assessmentData",
    setTableData: "setAssessmentData",
  },
  brsr_table_36: {
    table: RehabilitationEmploymentTable,
    tableData: "rehabdata",
    setTableData: "setRehabData",
  },
  brsr_table_37: {
    table: ValueChainAssessmentTable,
    tableData: "valuedata",
    setTableData: "setValueData",
  },
  brsr_table_38: {
    table: StakeholderEngagementTable,
    tableData: "stakeholderdata",
    setTableData: "setStakeholderData",
  },
  brsr_table_39: {
    table: CoverageComparisonTable,
    tableData: "coveragedata",
    setTableData: "setCoverageData",
  },
  brsr_table_40: {
    table: WageDistributionTable,
    tableData: "wageData",
    setTableData: "setWageData",
  },
  brsr_table_41: {
    table: RemunerationTable,
    tableData: "remunerationdata",
    setTableData: "setRemunerationData",
  },
  brsr_table_42: {
    table: FemaleWagePercentageTable,
    tableData: "femaleWageData",
    setTableData: "setFemaleWageData",
  },
  brsr_table_43: {
    table: HumanRightsComplaintsTable,
    tableData: "humanrightsdata",
    setTableData: "setHumanrightsData",
  },
  brsr_table_44: {
    table: PoshComplaintsTable,
    tableData: "poshData",
    setTableData: "setPoshData",
  },
  brsr_table_45: {
    table: PlantAssessmentTable,
    tableData: "plantAssessmentData",
    setTableData: "setPlantAssessmentData",
  },
  brsr_table_46: {
    table: PartnerEthicsAssessmentTable,
    tableData: "valueChainAssessmentData",
    setTableData: "setValueChainAssessmentData",
  },
  brsr_table_47: {
    table: EnergyConsumptionTable,
    tableData: "energyData",
    setTableData: "setEnergyData",
  },
  brsr_table_48: {
    table: WaterWithdrawalAndConsumptionTable,
    tableData: "waterData",
    setTableData: "setWaterData",
  },
  brsr_table_49: {
    table: WaterDischargeTreatmentTable,
    tableData: "dischargeData",
    setTableData: "setDischargeData",
  },
  brsr_table_50: {
    table: AirPollutantEmissionTable,
    tableData: "airdata",
    setTableData: "setAirData",
  },
  brsr_table_51: {
    table: Scope1And2GHGEmissionTable,
    tableData: "scopeData",
    setTableData: "setScopeData",
  },
  brsr_table_52: {
    table: WasteManagementEntityTable,
    tableData: "wasteManagementData",
    setTableData: "setWasteManagementData",
  },
  brsr_table_53: {
    table: EnvironmentalClearanceTable,
    tableData: "envclearanceData",
    setTableData: "setEnvClearanceData",
  },
  brsr_table_54: {
    table: EIAComplianceTable,
    tableData: "eiaData",
    setTableData: "setEiaData",
  },
  brsr_table_55: {
    table: RegulatoryNonComplianceTable,
    tableData: "nonComplianceData",
    setTableData: "setNonComplianceData",
  },
  brsr_table_56: {
    table: WaterUsageAndDischargeTable,
    tableData: "waterusagedata",
    setTableData: "setWaterUsageData",
  },
  brsr_table_57: {
    table: Scope3EmissionsTable,
    tableData: "scope3Data",
    setTableData: "setScope3Data",
  },
  brsr_table_58: {
    table: InitiativeOutcomeTable,
    tableData: "initiativeData",
    setTableData: "setInitiativeData",
  },
  brsr_table_59: {
    table: TradeAssociationsTable,
    tableData: "associations",
    setTableData: "setAssociations",
  },
  brsr_table_60: {
    table: LegalAuthoritiesTable,
    tableData: "authorityData",
    setTableData: "setAuthorityData",
  },
  brsr_table_61: {
    table: PublicPolicyAdvocacyTable,
    tableData: "advocacyData",
    setTableData: "setAdvocacyData",
  },
  brsr_table_62: {
    table: SIATable,
    tableData: "siaData",
    setTableData: "setSiaData",
  },
  brsr_table_63: {
    table: RehabilitationResettlementTable,
    tableData: "resettlementData",
    setTableData: "setResettlementData",
  },
  brsr_table_64: {
    table: SourcingBreakdownTable,
    tableData: "sourcingData",
    setTableData: "setSourcingData",
  },
  brsr_table_65: {
    table: LocationDistributionTable,
    tableData: "locationData",
    setTableData: "setLocationData",
  },
  brsr_table_66: {
    table: SocialImpactActionTable,
    tableData: "socialImpactData",
    setTableData: "setSocialImpactData",
  },
  brsr_table_67: {
    table: AspirationalDistrictTable,
    tableData: "aspirationalDistrictData",
    setTableData: "setAspirationalDistrictData",
  },
  brsr_table_68: {
    table: TraditionalKnowledgeTable,
    tableData: "traditionalKnowledgeData",
    setTableData: "setTraditionalKnowledgeData",
  },
  brsr_table_69: {
    table: RegulatoryCaseTable,
    tableData: "regulatoryCaseData",
    setTableData: "setRegulatoryCaseData",
  },
  brsr_table_70: {
    table: CSRBeneficiariesTable,
    tableData: "csrBeneficiaryData",
    setTableData: "setCsrBeneficiaryData",
  },
  brsr_table_71: {
    table: TurnoverParameterTable,
    tableData: "turnoverData",
    setTableData: "setTurnoverData",
  },
  brsr_table_72: {
    table: CustomerComplaintsTable,
    tableData: "complaintData",
    setTableData: "setComplaintData",
  },
  brsr_table_73: {
    table: ProductRecallTable,
    tableData: "recallData",
    setTableData: "setRecallData",
  },
};
